import { ROUTE_SIGN_IN } from '@/constants/routes';
import { useMe } from '@/context/me/me.context';
import useAnalyticsCalls from '@/hooks/use-analytics';
import { useSetNavbarHeight } from '@/queries/layout.queries';
import authService from '@/services/auth.service';
import { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function useDashboardNavigationBarController() {
  const navigate = useNavigate();
  const analytics = useAnalyticsCalls();
  const { data } = useMe();
  const name = data?.profile?.name;
  const email = data?.account?.credential;
  const setNavbarHeightMutation = useSetNavbarHeight();
  const [navBarHeight, setNavBarHeight] = useState(56);
  const [notificationHeight, setNotificationHeight] = useState(0);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  function handleLogout() {
    authService.logout();
    navigate(ROUTE_SIGN_IN);
    analytics.callLogoutCompleted();
  }

  const navBarRef = useCallback((node: HTMLDivElement) => {
    if (!node) setNavBarHeight(0);
    if (node !== null) setNavBarHeight(node.getBoundingClientRect().height);
  }, []);

  const notificationRef = useCallback((node: HTMLDivElement) => {
    if (!node) setNotificationHeight(0);
    if (node !== null) setNotificationHeight(node.getBoundingClientRect().height);
  }, []);

  useEffect(() => {
    setNavbarHeightMutation.mutateAsync(navBarHeight + notificationHeight);
  }, [navBarHeight, notificationHeight]);

  return { name, email, handleLogout, navBarRef, notificationRef, isMobileMenuOpen, setIsMobileMenuOpen };
}
